var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulbIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13037",
    "data-name": "Group 13037",
    transform: "translate(0.109 -0.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11830",
    "data-name": "Group 11830",
    transform: "translate(19.763 5.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M149.945,75.684h-26.29a1.465,1.465,0,0,1-1.469-1.462V71.587a36.748,36.748,0,0,0-5.925-19.455,23.8,23.8,0,0,1-3.565-14.9A24.237,24.237,0,0,1,153.48,21.969a23.965,23.965,0,0,1,4.026,29.895,39.5,39.5,0,0,0-6.092,20.45v1.909A1.465,1.465,0,0,1,149.945,75.684Zm-24.819-2.925h23.348v-.446a42.421,42.421,0,0,1,6.519-21.97,21.049,21.049,0,0,0-3.539-26.256,21.294,21.294,0,0,0-35.83,13.4,20.911,20.911,0,0,0,3.128,13.093,39.655,39.655,0,0,1,6.373,21.006Z",
    transform: "translate(-106.759 -15.334)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M119.178,31.664a1.475,1.475,0,0,1-.68-.168,1.457,1.457,0,0,1-.62-1.974,17.876,17.876,0,0,1,9.372-8.352,1.463,1.463,0,1,1,1.066,2.725,14.953,14.953,0,0,0-7.834,6.984A1.472,1.472,0,0,1,119.178,31.664Z",
    transform: "translate(-103.573 -11.805)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M128.072,59.75a1.466,1.466,0,0,1-1.471-1.462V46.98a1.459,1.459,0,0,1,.6-1.176l5.831-4.278a1.474,1.474,0,0,1,2.055.31,1.458,1.458,0,0,1-.31,2.045l-5.234,3.839V58.289A1.465,1.465,0,0,1,128.072,59.75Z",
    transform: "translate(-98.03 0.6)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M130.311,59.75a1.466,1.466,0,0,1-1.471-1.462V47.72l-5.234-3.839a1.458,1.458,0,0,1-.31-2.045,1.473,1.473,0,0,1,2.055-.31l5.831,4.277a1.46,1.46,0,0,1,.6,1.177V58.289A1.465,1.465,0,0,1,130.311,59.75Z",
    transform: "translate(-100.269 0.6)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M127.208,44.763a1.465,1.465,0,0,1-1.292-2.158l4.065-7.478h-3.859a1.464,1.464,0,0,1-1.2-2.3l5.139-7.276a1.48,1.48,0,0,1,2.049-.355,1.46,1.46,0,0,1,.357,2.038L128.953,32.2h3.5a1.476,1.476,0,0,1,1.263.712,1.458,1.458,0,0,1,.029,1.445L128.5,44A1.471,1.471,0,0,1,127.208,44.763Z",
    transform: "translate(-99.245 -9.434)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M143.531,75.2H125.1a5.146,5.146,0,0,1-5.152-5.128V66.545a4.134,4.134,0,0,1-3.362-4.049V54.274a3.4,3.4,0,0,1,3.4-3.384h28.663a3.4,3.4,0,0,1,3.4,3.384V62.5a4.134,4.134,0,0,1-3.362,4.049v3.522A5.146,5.146,0,0,1,143.531,75.2Zm-23.548-21.38a.459.459,0,0,0-.459.459V62.5a1.2,1.2,0,0,0,1.2,1.2h.687a1.466,1.466,0,0,1,1.471,1.462v4.911a2.209,2.209,0,0,0,2.213,2.2h18.433a2.209,2.209,0,0,0,2.213-2.2V65.156a1.466,1.466,0,0,1,1.471-1.462h.688a1.2,1.2,0,0,0,1.2-1.2V54.274a.459.459,0,0,0-.459-.459Z",
    transform: "translate(-104.274 6.535)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M134.92,74.534h-7.031a6.627,6.627,0,0,1-6.636-6.6V65.59a1.468,1.468,0,0,1,1.471-1.463h17.362a1.468,1.468,0,0,1,1.471,1.463v2.342A6.627,6.627,0,0,1,134.92,74.534Zm-10.727-7.481v.879a3.692,3.692,0,0,0,3.7,3.678h7.031a3.692,3.692,0,0,0,3.7-3.678v-.879Z",
    transform: "translate(-101.364 14.677)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M138.129,61.743h-18a1.462,1.462,0,1,1,0-2.925h18a1.462,1.462,0,1,1,0,2.925Z",
    transform: "translate(-102.983 11.412)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M143.2,39.657a1.462,1.462,0,0,1-.253-2.9l4.015-.7a1.462,1.462,0,1,1,.511,2.88l-4.016.7A1.388,1.388,0,0,1,143.2,39.657Z",
    transform: "translate(-88.602 -2.606)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M147.215,45.429a1.562,1.562,0,0,1-.258-.023l-4.015-.7a1.463,1.463,0,1,1,.51-2.881l4.016.7a1.463,1.463,0,0,1-.253,2.9Z",
    transform: "translate(-88.602 0.943)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M144.9,51.765a1.47,1.47,0,0,1-.734-.2l-3.531-2.029a1.458,1.458,0,0,1-.539-2,1.474,1.474,0,0,1,2.008-.536l3.531,2.029a1.462,1.462,0,0,1-.735,2.729Z",
    transform: "translate(-89.739 4.026)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M112.6,51.765a1.462,1.462,0,0,1-.735-2.729l3.531-2.029a1.474,1.474,0,0,1,2.008.536,1.458,1.458,0,0,1-.539,2l-3.531,2.029A1.47,1.47,0,0,1,112.6,51.765Z",
    transform: "translate(-107.678 4.026)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M110.47,45.429a1.463,1.463,0,0,1-.255-2.9l4.016-.7a1.463,1.463,0,1,1,.51,2.881l-4.015.7A1.543,1.543,0,0,1,110.47,45.429Z",
    transform: "translate(-109.001 0.943)",
    fill: "#2eafbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M114.488,39.657a1.388,1.388,0,0,1-.256-.023l-4.016-.7a1.462,1.462,0,1,1,.511-2.88l4.015.7a1.462,1.462,0,0,1-.253,2.9Z",
    transform: "translate(-109.001 -2.606)",
    fill: "#2eafbe"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1008",
    "data-name": "Rectangle 1008",
    width: 100,
    height: 100,
    transform: "translate(-0.109 0.112)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbIcon);
export default __webpack_public_path__ + "static/media/bulb-icon.4b851bd9f3296b609b088991f59ed51c.svg";
export { ForwardRef as ReactComponent };